/*
 * @Author: edvardchen
 * @Date:   2016-10-24 21:55:33
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 16:12:53
 */

// @flow
import _ from 'lodash';
import { isomorphicConfig } from '../utility';
import { post } from '../fetchers/fetch';

const trackMap = {};
/**
 * 上报用户行为数据
 * @param  {String}        options.location 位置
 * @param  {String}        options.action   动作
 * @param  {String}        options.object   对象
 * @param  {String}        options.ch       渠道
 * @param  {String|Number} options.id       唯一标识
 * @param  {Any}           options.ext      扩展信息
 * @return {Promise}
 */
export default function track({
  location,
  action,
  object,
  id,
  ch,
  ext,
  whiteList = [],
  grayConfig = {},
}: {
  location: string,
  action: string,
  object: string,
  id: string | number,
  ext: string,
  ch: string,
  whiteList?: [],
  grayConfig?: Object,
}) {
  const one =
    grayConfig[_.findKey(grayConfig, (item, key) => whiteList.indexOf(key) >= 0 && item && item.isAble) || ''];
  const grayId = (one && one.grayId) || '';
  const obj = grayId ? `${object}_${grayId}` : object;

  const url = `${isomorphicConfig.zixunHost}/coolread/api/usertrack`;

  return post(url, {
    body: {
      location,
      action,
      object: obj,
      id,
      ch,
      ext,
    },
  });
}

/**
 * 上报用户行为数据，相同location/action/object/id上报会被合并为一条，不支持ext字段，这里会被用于累计次数
 * @param  {String}        options.location 位置
 * @param  {String}        options.action   动作
 * @param  {String}        options.object   对象
 * @param  {String}        options.ch       渠道
 * @param  {String|Number} options.id       唯一标识
 */
export function batchTrack({
  location = '',
  action = '',
  object = '',
  id = '',
  ch = '',
}: {
  location: string,
  action: string,
  object: string,
  id: string,
  ch?: string,
}) {
  const key = location + action + object + id;
  trackMap[key] = (trackMap[key] || 0) + 1;
  const count = trackMap[key];
  setTimeout(() => {
    if (trackMap[key] === count) {
      track({ location, action, object, id, ch, ext: count });
      trackMap[key] = undefined;
    }
  }, 1000);
}

/**
 * 上报用户行为数据，相同location/action/object/id上报会被合并为一条，ext字段会被合并，用#连接
 * @param  {String}        options.location 位置
 * @param  {String}        options.action   动作
 * @param  {String}        options.object   对象
 * @param  {String}        options.ch       渠道
 * @param  {String|Number} options.id       唯一标识
 * @param  {String}        options.ext      扩展信息
 */
export function batchTrackWithExt({
  location = '',
  action = '',
  object = '',
  id = '',
  ch = '',
  ext = '',
  whiteList = [],
  grayConfig = {},
}: {
  location: string,
  action: string,
  object: string,
  id: string,
  ch?: string,
  ext: string,
  whiteList?: [],
  grayConfig?: Object,
}) {
  if (!ext) {
    return;
  }
  const key = location + action + object + id;
  let old = trackMap[key] || '';
  old = old ? `${old}#${ext}` : ext;
  trackMap[key] = old;
  setTimeout(() => {
    if (trackMap[key] === old) {
      track({ location, action, object, id, ch, ext: old, whiteList, grayConfig });
      trackMap[key] = undefined;
    }
  }, 3000);
}

/**
 * 话题圈行为上报(产品有时要求如PK竞猜这种按照话题圈那一套上报，估计是为了KPI数据好看吧)
 * @param {Object} opt 统计信息对象
 * @param {string} opt.channel2 channel_v2内容
 * @param {string} opt.isConsume 是否为消费行为: '0'为否；'1'为是
 * @param {string} opt.actionType 动作类型
 * @param {string} opt.contentType 内容类型
 * @param {string} opt.contentId 内容id
 * @param {string} opt.pageType 页面类型
 * @param {string} opt.circleId 圈id
 * @param {string} opt.recommModelId 推荐模型id
 */
export function quanActionReport({
  channel2,
  isConsume,
  actionType,
  contentType,
  contentId,
  pageType,
  circleId,
  recommModelId,
}: {
  channel2: string,
  isConsume?: string,
  actionType?: string,
  contentType?: string,
  contentId?: string,
  pageType?: string,
  circleId?: string,
  recommModelId?: string,
}) {
  const url = 'https://quan.qq.com/web/api/log';
  if (typeof window === 'undefined') {
    return;
  }
  const obj = {
    channel: '000000',
    innerChannel: channel2 || '000000',
    isConsumeAction: isConsume || '0',
    actionType: actionType || '',
    contentType: contentType || '',
    contentId: contentId || '',
    pageType: pageType || '',
    circleId: circleId || '',
  };
  if (recommModelId) {
    obj[recommModelId] = recommModelId;
  }

  return post(url, {
    body: {
      type: 'stat',
      msg: JSON.stringify(obj),
    },
  });
}
